import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

/** store state model */
export interface EditAccountState {
  /**
   * ### 編集対象ユーザーID
   * URLパラメータでユーザーIDを使用するとセキュリティ的に問題があるので、storeで保持している
   */
  userId: string;
}

/**
 * ### EditAccount store
 *
 */
@Module({ name: "editAccount" })
export default class EditAccount extends VuexModule implements EditAccountState {
  userId: string = "";

  @Mutation
  private SET_USERID(userId: string): void {
    this.userId = userId;

    return;
  }

  /**
   * ### 編集対象ユーザーIDを設定する
   *
   * - { rawError: true }を設定しないと例外発生時に正しくエラーが上位に投げられない
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public setUserId(payload: { userId: string }): void {
    this.SET_USERID(payload.userId);

    return;
  }
}
